module.exports = __webpack_public_path__ + "static/media/SVG_locate.e485818d.svg";